// import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
// import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import { UPLOAD_DIRECTORY, UPLOAD } from '../../../../../../constants/Define';
import { readableFileSize, detectMimeFromMagicBytes } from '../../../../../../utils/commonUtils';

export default class HMSUploadAdapter {
    constructor(loader, config, t) {
        // The file loader instance to use during the upload.
        this.loader = loader;
        this.config = config || {};
        this.t = t || (s => s);
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                this._validateFile(file)
                    .then(() => {
                        this._initRequest();
                        this._initListeners(resolve, reject, file);
                        this._sendRequest(file);
                    })
                    .catch(reject);
            }));
    }

    // Aborts the upload process.
    abort() {
        if (this.xhr) {
            this.xhr.abort();
        }
    }

    // Initializes the XMLHttpRequest object using the URL passed to the constructor.
    _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();
        // Note that your request may look different. It is up to you and your editor
        // integration to choose the right communication channel. This example uses
        // a POST request with JSON as a data structure but your configuration
        // could be different.
        xhr.open('POST', this.config.url, true);
        // xhr.responseType = 'json';
        Object.keys(this.config.headers || {}).forEach(header => xhr.setRequestHeader(header, this.config.headers[header]));
    }

    // Initializes XMLHttpRequest listeners.
    _initListeners(resolve, reject, file) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = this.t(`cantUploadImageFile`) + `: ${file.name}`;
        if (file.size > UPLOAD.MAX_FILE_SIZE) {
            const errorMess = `${this.t('validation.statusCode.code.FILE_LENGTH_OVER_LIMIT')}. ${this.t('notification.maxFileSize')}: ${readableFileSize(UPLOAD.MAX_FILE_SIZE, 0)}`
            reject(errorMess);
        }
        xhr.addEventListener('error', () => reject(genericErrorText));
        xhr.addEventListener('abort', () => reject());
        xhr.addEventListener('load', () => {
            const response = xhr.response;

            // This example assumes the XHR server's "response" object will come with
            // an "error" which has its own "message" that can be passed to reject()
            // in the upload promise.
            //
            // Your integration may handle upload errors in a different way so make sure
            // it is done properly. The reject() function must be called when the upload fails.
            if (!response || response.error) {
                return reject(response && response.error ? response.error.message : genericErrorText);
            }
            let url;
            try {
                const respJson = JSON.parse(response);
                if (respJson && respJson.data && this.config.urlParser) {
                    url = this.config.urlParser(respJson.data);
                } else {
                    url = respJson.data.fileUrl || respJson.data.fileUri;
                }
            } catch (error) {
                url = response;
            }

            // If the upload is successful, resolve the upload promise with an object containing
            // at least the "default" URL, pointing to the image on the server.
            // This URL will be used to display the image in the content. Learn more in the
            // UploadAdapter#upload documentation.
            resolve({
                default: url
            });
        });

        // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
        // properties which are used e.g. to display the upload progress bar in the editor
        // user interface.
        if (xhr.upload) {
            xhr.upload.addEventListener('progress', evt => {
                if (evt.lengthComputable) {
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            });
        }

    }

    _validateFile(file) {
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml', 'image/gif'];
        return detectMimeFromMagicBytes(file).then((mime) => {
            if (!mime || !allowedTypes.includes(mime)) {
                throw this.t('validation.statusCode.code.FILE_TYPE_NOT_ACCEPTED');
            }
        });
    }

    // Prepares the data and sends the request.
    _sendRequest(file) {
        // Prepare the form data.
        const data = new FormData();

        data.append('file', file);
        data.append('directory', this.config.directory || UPLOAD_DIRECTORY.GENERAL);
        // const data = { file, directory: this.config.directory || 'general' }

        // Important note: This is the right place to implement security mechanisms
        // like authentication and CSRF protection. For instance, you can use
        // XMLHttpRequest.setRequestHeader() to set the request headers containing
        // the CSRF token generated earlier by your application.

        // Send the request.
        this.xhr.send(data);
    }
}

// export class RichTextUploadAdapter extends Plugin {

// 	static get requires() {
//         return [FileRepository];
//     }
// 	static get pluginName() {
//         return 'RichTextUploadAdapter';
//     }

//     init() {
//         const uploadConfig = this.editor.config.get('uploadConfig') || {};
//         if (!uploadConfig.url) {
//             return;
//         }
//         this.editor.plugins.get(FileRepository).createUploadAdapter = loader => new HMSUploadAdapter(loader, uploadConfig, this.editor.t);
//     }
// }
